export const UserInitialState = {
  Login: "",
  ShippingType: 0,
  config: null,
};

export const UserReducer = (state, { type, payload }) => {
  switch (type) {
    case "UPDATE":
      return { ...state, ...payload };
    default:
      return state;
  }
};
